import { APIClient } from "./_api";

const endpoint = "/ProductPricing";

export function getAllProductPricing() {
  return APIClient.get(`${endpoint}`);
}

export function addProductPricing(data) {
  return APIClient.post(`${endpoint}`, data);
}

export function editProductPricing(data, id) {
  return APIClient.put(`${endpoint}/${id}`, data);
}

export function deleteProductPricing(id) {
  return APIClient.delete(`${endpoint}/${id}`);
}
